import { isPlainObject, type ThunkAction } from "@reduxjs/toolkit";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { type AppDispatch } from "store";

/**
 * @deprecated
 * Выпить данный хук. Вызов refresh token происходит в interceptors
 */
export const useAsyncDispatch = () => {
  const dispatchRedux = useDispatch<AppDispatch>();

  const dispatch = useCallback(
    async (action: any) => {
      if (isPlainObject(action)) {
        dispatchRedux(action as ThunkAction<unknown, unknown, unknown, any>);
      } else {
        const initialActionThunk = await dispatchRedux(action);
        // const { meta, error } = initialActionThunk;
        // if (meta.requestStatus !== ERequestStatus.FULFILLED) {
        //   if (error.status === 401) {
        // localStorage.removeItem(LStorage.AUTH);
        // await dispatchRedux(signOut());
        // window.location.href = `${window.location.protocol}//${window.location.host}/login`;
        // TODO when ready
        // const refreshTokenThunk = await dispatchRedux(RefreshToken());
        // if (
        //   refreshTokenThunk.meta.requestStatus === ERequestStatus.FULFILLED
        // ) {
        //   const retryAction = await dispatchRedux(action);
        //   return retryAction;
        // }
        //   }
        //   return initialActionThunk;
        // } else {
        //   return initialActionThunk;
        // }
        return initialActionThunk;
      }
    },
    [dispatchRedux]
  );

  return dispatch;
};
